import React, { useRef } from "react";
import SwiperCore from "swiper";
import Image from "next/image";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// interfaces
import { ICardCarousel } from "./ICardCarousel";

// assets
import "swiper/css";
import "swiper/css/pagination";
import styles from "@/assets/styles/components/card-carousel.module.scss";


function CardCarousel({ items, className = "", imgWidth, imgHeight }: ICardCarousel) {
  const swiperRef = useRef<SwiperCore | null>(null);
  const isMoreThenOneImage = items && items?.length > 1;

  const handlePrevClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
    swiperRef.current?.slidePrev();
  }
  const handleNextClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
    swiperRef.current?.slideNext();
  }

  return (
    <Swiper
      spaceBetween={24}
      modules={[Pagination]}
      pagination={{ clickable: true, }}
      onBeforeInit={(swiper) => {
        swiperRef.current = swiper;
      }}
      loop
      className={`${styles["locl-card-carousel"]} ${className}`}
      data-testid="locl-card-carousel"
    >
      {
        isMoreThenOneImage && (
          <div
            onClick={handlePrevClick}
            className={`${styles["locl-card-carousel__navigation"]} ${styles["locl-card-carousel__navigation_left"]}`}
            data-testid="locl-card-carousel-navigation-left"
          >
            <FaChevronLeft/>
          </div>
        )
      }
      {
        (items || []).map((item, index: number) => (
          <SwiperSlide
            key={`SpaceCardCarousel-${index}-${item.alt}`}
            className={styles["locl-card-carousel__slide"]}
          >
            <Image
              width={imgWidth || 160}
              height={imgHeight || 100}
              loading="lazy"
              src={item.src}
              alt={item.alt}
              className={styles["locl-card-carousel__slide-image"]}
              quality={75}
            />
          </SwiperSlide>
        ))
      }
      {
        isMoreThenOneImage && (
          <div
            onClick={handleNextClick}
            className={`${styles["locl-card-carousel__navigation"]} ${styles["locl-card-carousel__navigation_right"]}`}
            data-testid="locl-card-carousel-navigation-right"
          >
            <FaChevronRight/>
          </div>
        )
      }
    </Swiper>
  );
}

export default CardCarousel;
